import { combineReducers } from "redux";
import tableReducer from "./tableReducer";
import ViewerReducer from "./viewerReducer";
import userReducer from "./userReducer";
import conditionReducer from "./conditionReducer";
import colorSidebarReducer from "./colorSidebarReducer"
import tabsSettingsReducer from "./tabsSettingsReducer";

const rootReducer = combineReducers({
  viewer: ViewerReducer,
  table: tableReducer,
  tabsSettings: tabsSettingsReducer,
  user: userReducer,
  condition: conditionReducer,
  colorSidebar: colorSidebarReducer,
});

export default rootReducer;
